import React, { useMemo, useRef, useState } from "react";
import { buildCategoryIndex } from "../utils/categoryIndex";

export const GlobalContext = React.createContext();

function GlobalContextProvider(props) {
  const [IsTimeout, setIsTimeout] = useState(false);
  const [CartItem, setCartItem] = useState(null);
  const [clarificationItem, setClarificationItem] = useState(null);
  const [OrderId, setOrderId] = useState(0);
  const [homeBanner, setHomeBanner] = useState(null);
  const [CategoryMenu, setCategoryMenu] = useState(null);
  const [categoryDataAll, setCategoryDataAll] = useState(null);
  const [linkedCategoryData, setLinkedCategoryData] = useState(null);
  const [categorySlider, setCategorySlider] = useState(null);
  const [WishList, setWishList] = useState(null);
  const [wishListAll, setWishListAll] = useState(null);
  const [aerosol, setAerosol] = useState(null);
  const [smsNumber, setSmsNumber] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [shippingAddressOriginal, setShippingAddressOriginal] = useState(null);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [addressOrderId, setAddressOrderId] = useState(null);
  const [billingAddress, setBillingAddress] = useState(null);
  const [billingAddressOriginal, setBillingAddressOriginal] = useState(null);
  const [newAddress, setNewAddress] = useState(null);
  const [suburbList, setSuburbList] = useState(null);
  const [countryList, setCountryList] = useState(null);
  const [addressType, setAddressType] = useState(null);
  const [shipService, setShipService] = useState(null);
  const [shippingCost, setShippingCost] = useState(null);
  const [shippingCode, setShippingCode] = useState(null);
  const [shippingMode, setShippingMode] = useState(null);
  const [netAmount, setNetAmount] = useState(null);
  const [totalTax, setTotalTax] = useState(null);
  const [changeAddressClicked, setChangeAddressClicked] = useState(false);
  const [addressBookClicked, setAddressBookClicked] = useState(false);
  const [poNumberRules, setPoNumberRules] = useState(null);
  const [poNumberRequired, setPoNumberRequired] = useState(false);
  const [poNumber, setPoNumber] = useState("");
  const [orderCommands, setOrderCommands] = useState("");
  const [paymentOption, setPaymentOption] = useState(null);
  const [storedCard, setStoredCard] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const [deliveryMethod, setDeliveryMethod] = useState(null);
  const [selectedPaymentType, setSelectedPaymentType] = useState(null);
  const [newcardName, setNewcardName] = useState("");
  const [newcardExp, setNewcardExp] = useState("");
  const [newCardSave, setNewcardSave] = useState(false);
  const [IsInterNational, setIsInterNational] = useState(null);
  const [uuid, setUuid] = useState(null);
  const [pickupOnlyProduct, setPickupOnlyProduct] = useState(null);
  const [promoCode, setPromoCode] = useState(null);
  const [isSubmitOrder, setIsSubmitOrder] = useState(false);
  const [isDropshipmentUser, setIsDropshipmentUser] = useState(false);
  const [algoliaProducts, setAlgoliaProducts] = useState(null);
  const [brandList, setBrandList] = useState(null);
  const [compatibleList, setCompatibleList] = useState(null);
  const [changeShipServiceClicked, setChangeShipServiceClicked] = useState(true);
  const [isGridView, setIsGridView] = useState(true);
  const [addressList, setAddressList] = useState([]);
  const historyRef = useRef([]);
  const shownPreviousOrderPopup = useRef(false);
  const smsNotificationCancelClicked = useRef(false);
  const smsEditInProgress = useRef(false);
  const [refreshable, setRefreshable] = useState(true);
  const [newCategoryData, setNewCategoryData] = useState(null);
  const categoryIndex = useMemo(() => buildCategoryIndex(categoryDataAll), [categoryDataAll]);
  return (
    <GlobalContext.Provider
      value={{
        IsTimeout,
        setIsTimeout,
        CartItem,
        setCartItem,
        CategoryMenu,
        setCategoryMenu,
        WishList,
        setWishList,
        OrderId,
        setOrderId,
        aerosol,
        setAerosol,
        smsNumber,
        setSmsNumber,
        shippingAddress,
        setShippingAddress,
        suburbList,
        setSuburbList,
        countryList,
        setCountryList,
        addressType,
        setAddressType,
        shipService,
        setShipService,
        shippingCost,
        setShippingCost,
        shippingCode,
        setShippingCode,
        shippingMode,
        setShippingMode,
        netAmount,
        setNetAmount,
        totalTax,
        setTotalTax,
        billingAddress,
        setBillingAddress,
        changeAddressClicked,
        setChangeAddressClicked,
        changeShipServiceClicked,
        setChangeShipServiceClicked,
        poNumberRequired,
        setPoNumberRequired,
        poNumberRules,
        setPoNumberRules,
        paymentOption,
        setPaymentOption,
        storedCard,
        setStoredCard,
        selectedCard,
        setSelectedCard,
        selectedPaymentType,
        setSelectedPaymentType,
        poNumber,
        setPoNumber,
        newcardName,
        setNewcardName,
        newcardExp,
        setNewcardExp,
        newCardSave,
        setNewcardSave,
        deliveryMethod,
        setDeliveryMethod,
        orderCommands,
        setOrderCommands,
        IsInterNational,
        setIsInterNational,
        uuid,
        setUuid,
        shippingAddressOriginal,
        setShippingAddressOriginal,
        pickupOnlyProduct,
        setPickupOnlyProduct,
        newAddress,
        setNewAddress,
        promoCode,
        setPromoCode,
        isSubmitOrder,
        setIsSubmitOrder,
        isDropshipmentUser,
        setIsDropshipmentUser,
        wishListAll,
        setWishListAll,
        billingAddressOriginal,
        setBillingAddressOriginal,
        categoryDataAll,
        setCategoryDataAll,
        categoryIndex,
        isGridView,
        setIsGridView,
        algoliaProducts,
        setAlgoliaProducts,
        brandList,
        setBrandList,
        addressBookClicked,
        setAddressBookClicked,
        addressList,
        setAddressList,
        historyRef,
        compatibleList,
        setCompatibleList,
        shownPreviousOrderPopup,
        smsNotificationCancelClicked,
        smsEditInProgress,
        clarificationItem,
        setClarificationItem,
        selectedAddressId,
        setSelectedAddressId,
        addressOrderId,
        setAddressOrderId,
        homeBanner,
        setHomeBanner,
        categorySlider,
        setCategorySlider,
        refreshable,
        setRefreshable,
        linkedCategoryData,
        setLinkedCategoryData,
        newCategoryData,
        setNewCategoryData,
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
}
export default GlobalContextProvider;
